import * as type from './action-types';

export const initialState = {
  showFooter: true,
  showHeader: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_SHOW_FOOTER:
      return Object.assign({}, state, {
        showFooter: true
      });

    case type.SET_HIDE_FOOTER:
      return Object.assign({}, state, {
        showFooter: false
      });

    case type.SET_SHOW_HEADER:
      return Object.assign({}, state, {
        showHeader: true
      });

    case type.SET_HIDE_HEADER:
      return Object.assign({}, state, {
        showHeader: false
      });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/topBottomSection/reducer.js
 **/